var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/** 無色透明の色の値 */
export var TransparentColor = 'transparent';
/**
 * 透明度を持たせた色を取得する
 * @param normalHexColor 末尾に透明度を示す２桁の数字を持たない色文字列
 * @returns
 */
export var getOpacityColor = function (normalHexColor) { return normalHexColor + "66"; };
/**
 * 透明度を外した色を取得する
 * @param opacityHexColor 末尾に透明度を示す２桁の数字を持つ色文字列
 * @returns
 */
export var getNormalColor = function (opacityHexColor) { return opacityHexColor.slice(0, -2); };
/** 色の種類リスト */
export var NormalColorList = ['#000000', '#f22524', '#2b72de', '#dfc800', '#3cb838'];
/** 透明度を持たせた色のリスト */
export var getOpacityColorList = function (colorList) { return colorList.map(function (color) { return getOpacityColor(color); }); };
/** 無色透明を色選択できるようにする */
export var getColorListWithTransparent = function (list) { return __spreadArrays(list, [TransparentColor]); };
/** 色の種類テーブル */
export var NormalColorTable = [
    ['#000000', '#f22524', '#2b72de', '#dfc800', '#3cb838', '#9459dc', '#e67702'],
    ['#ffffff', '#facece', '#ddeff9', '#fefcd7', '#dbf8e2', '#f9e9fc', '#fdf1df'],
    ['#d0d0d0', '#f68989', '#99d7f6', '#f7ed7b', '#95e994', '#ddaff5', '#f9c57b'],
    ['#686868', '#a70000', '#1841a1', '#ae9b00', '#27821e', '#701fd4', '#994200'],
];
/** 透明度を持たせた色のテーブル */
export var getOpacityColorTable = function (colorTable) {
    return colorTable.map(function (colorList) { return getOpacityColorList(colorList); });
};
/** 無色透明を色選択できるようにする */
export var getColorTableWithTransparent = function (table) { return __spreadArrays(table, [[TransparentColor]]); };
